import Api from './api';

const createCarHiddenFieldRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/fields', data, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const deleteCarHiddenFieldRequest = (fieldId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/fields/' + fieldId,  { headers:
            {
                Authorization: 'Bearer ' + access_token,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
    })
}


export default {
    createCarHiddenFieldRequest,
    deleteCarHiddenFieldRequest
}



// WEBPACK FOOTER //
// ./src/api/apiCarHiddenFields.js